import React from 'react';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

import DeleteBookmarkButton from 'app/components/BookmarkMenu/DeleteBookmarkButton';
import ClearBookmarksButton from 'app/components/BookmarkMenu/ClearBookmarksButton';
import BookmarksButton from 'app/components/MainMenu/BookmarksButton';

function BookmarksMenu({ AppState }) {
  if (!AppState.isBookmarksMenuBar) return null;
  const hasBookmarks = !_.isEmpty(AppState.bookmarks.collection);
  return (
    <React.Fragment>
      {hasBookmarks && <DeleteBookmarkButton />}
      {hasBookmarks && <ClearBookmarksButton />}
      {!hasBookmarks && <div/>}
      <BookmarksButton />
    </React.Fragment>
  );
}

export default inject('AppState')(observer(BookmarksMenu));



// WEBPACK FOOTER //
// ./src/app/components/BookmarkMenu/BookmarksMenu.js